<template>
    <div>
        <table class="table table-bordered table-striped datatable" width="100%" id="datatable">
            <thead>
            <tr>
              <th>Fecha alta</th>
                <th></th>
                <th>Vehículo</th>
                <th>Matrícula</th>
                <th>Localización</th>
                <th>Precio</th>
                <th>Tipo</th>
                <th>Vista previa</th>
              <th><img src="https://s3.eu-west-1.amazonaws.com/montalt-cars/assets/comprar_coche_online.png" style="max-width:95px;" /></th>
              <th><img src="https://s.ccdn.es/images/logo-coches.svg" style="max-width:95px;" /></th>
            </tr>
            </thead>
            <tfoot>
            <tr>
                <th>Fecha alta</th>
                <th></th>
                <th>Vehículo</th>
                <th>Matrícula</th>
                <th>Localización</th>
                <th>Precio</th>
                <th>Tipo</th>
                <th>Vista previa</th>
              <th><img src="https://s3.eu-west-1.amazonaws.com/montalt-cars/assets/comprar_coche_online.png" style="max-width:95px;" /></th>
              <th><img src="https://s.ccdn.es/images/logo-coches.svg" style="max-width:95px;" /></th>
            </tr>
            </tfoot>
        </table>

      <div class="modal fade" tabindex="-1" role="dialog" id="modalPublish">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title" id="car_description"></h4>

            </div>
            <div class="modal-body">
              <p id="askText"></p>
              <p id="paragraphText"></p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Cancelar</button>
              <button type="button" class="btn btn-success" id="btnDoAction">PUBLICAR</button>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
      </div><!-- /.modal -->
      <div class="modal fade" tabindex="-1" role="dialog" id="modalProgressPublish">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <h4 class="modal-title"><img src="https://s.ccdn.es/images/logo-coches.svg" style="max-width:95px;" /></h4>
              <p id="progressText">Publicando vehículo…</p>
              <div class="overlay">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
            </div>
            <div class="modal-footer">
              <small>Esta operación puede tardar hasta 1 minuto (depende de coches.net)</small>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
      </div><!-- /.modal -->

      <div class="modal fade" tabindex="-1" role="dialog" id="modalQuotaReached">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title"><i class="fas fa-exclamation-triangle" style="color: red"></i> La solicitud no se ha podido procesar.</h4>
            </div>
            <div class="modal-body">
              <p>Se ha superado la cuota de publicaciones para este vehículo, despublica otro vehículo antes de continuar.…</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
            </div>
          </div><!-- /.modal-content -->

        </div><!-- /.modal-dialog -->
      </div><!-- /.modal -->

      <div class="modal fase" role="dialog" id="modal_despublishing">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title"><i class="fas fa-exclamation-triangle" style="color: red"></i> La solicitud no se ha podido procesar.</h4>
            </div>
            <div class="modal-body">
              <p>Se ha superado la cuota de publicaciones para este vehículo, despublica otro vehículo antes de continuar.…</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal -->
      </div>

      <insert-sale-record-entry-component v-on:addedSaleEntry="onAddedSaleEntry" ref="insertSaleRecordEntry"></insert-sale-record-entry-component>
      <reserve-car-component
          v-on:onCreatedCarReserve="onCreatedCarReserve"
          v-on:onRemovedCarReserve="onRemovedCarReserve"
          ref="reserveCarComponent"></reserve-car-component>
      <un-publish-car-component
          ref="unPublishCarComponent"
          v-on:onUnpublishCar="onUnpublishCar"></un-publish-car-component>
      <publish-car-component
          ref="publishCarComponent"
          v-on:onPublishCar="onPublishCar"></publish-car-component>
    </div>
</template>

<script>
import 'datatables.net-bs'
import 'datatables.net-responsive-bs'
import moment from 'moment'
import BtnGroupWrapper from '../../custom/BtnGroupWrapper'
import InsertSaleRecordEntryComponent from '../../../components/custom/InsertSaleRecordEntryComponent'
import ReserveCarComponent from '../../../components/custom/ReserveCarComponent'
import UnPublishCarComponent from '../../../components/custom/UnpublishComponent'
import PublishCarComponent from '../../../components/custom/PublishCarComponent'
import { EventBus } from '../../../utils/EventBus'

window.openModal = function (askText, paragraphText, textButton, buttonOkCallback) {
  window.$('#modalCarFulltext').html(paragraphText)
  let askTextEl = window.$('#askText')
  let paragraphTextEl = window.$('#paragraphText')
  let btnAction = window.$('#btnDoAction')

  btnAction.unbind()
  btnAction.html(textButton)
  btnAction.on('click', buttonOkCallback)

  askTextEl.html(askText)
  paragraphTextEl.html(paragraphText)

  window.$('#modalPublish').modal()
}

window.closeModal = function () {
  window.$('#modalPublish').modal('hide')
}

window.showLoadingModal = function (operationText) {
  window.$('#progressText').html(operationText)

  window.$('#modalProgressPublish').modal({
    keyboard: false,
    show: true,
    backdrop: false
  })
}

window.hideLoadingModal = () => window.$('#modalProgressPublish').modal('hide')

window.tableInstance = {
  name: 'Datatable',
  components: {'btn-group-wrapper': BtnGroupWrapper, InsertSaleRecordEntryComponent, ReserveCarComponent, UnPublishCarComponent, PublishCarComponent},
  methods: {
    onAddedSaleEntry () {
      window.datatable.fnDraw(false)
      this.$store.dispatch('app/syncCarfactoryDealerQuota')
    },
    onRemovedCarReserve () {
      window.datatable.fnDraw(false)
      this.$store.dispatch('app/syncCarfactoryDealerQuota')
    },
    onUnpublishCar () {
      window.datatable.fnDraw(false)
      this.$store.dispatch('app/syncCarfactoryDealerQuota')
    },
    onPublishCar () {
      window.datatable.fnDraw(false)
      this.$store.dispatch('app/syncCarfactoryDealerQuota')
    },
    onCreatedCarReserve () {
      window.datatable.fnDraw(false)
      this.$store.dispatch('app/syncCarfactoryDealerQuota')
    },
    setCarAvailable (code) {
      alert(`action of set car available ${code}`)
    },
    setCarReserved (code) {
      alert(`action of reserve car ${code}`)
    },
    setCarSelled (code) {
      alert(`action of set car as selled ${code}`)
    },
    setCarUnpublished (code) {
      alert(`set car as unpublished ${code}`)
    }
  },
  mounted () {
    let self = this
    // window.vm.$on('unpublishEvent', event => {
    //   console.log('unpublishEvent window.vm', event)
    // })

    EventBus.$on('sellCarCnetEvent', event => {
      this.$refs.insertSaleRecordEntry.openForCar(event.code)
    })
    EventBus.$on('reserveCnetEvent', event => {
      this.$refs.reserveCarComponent.openForCar(event.code, 4, false)
    })
    EventBus.$on('unpublishCnetEvent', event => {
      this.$refs.unPublishCarComponent.openForCar(event.code)
    })
    EventBus.$on('publishCnetEvent', event => {
      this.$refs.publishCarComponent.openForCar(event.code)
    })
    EventBus.$on('unReserveCnetEvent', event => {
      this.$refs.reserveCarComponent.openForCar(event.code, 4, true)
    })

    // noinspection JSUnresolvedFunction
    // noinspection JSUnusedGlobalSymbols
    window.onSearchParamsChanged = (searchParams) => {
      window.searchParams = searchParams
      if (window.datatable !== null) {
        window.datatable.fnDraw(true)
      }
    }

    window.datatable = window.$('#datatable').dataTable({
      lengthChange: false,
      responsive: {
        details: false
      },
      bSort: true,
      language: {
        'sProcessing': 'Buscando resultados…',
        'aDataSort': 'Ordenar por',
        'sLengthMenu': 'Mostrar _MENU_ registros',
        'sZeroRecords': 'No se encontraron resultados',
        'sEmptyTable': 'Ningún dato disponible en esta tabla',
        'sInfo': 'Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros',
        'sInfoEmpty': 'Mostrando registros del 0 al 0 de un total de 0 registros',
        'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
        'sInfoPostFix': '',
        'sSearch': 'Buscar:',
        'sUrl': '',
        'sType': 'tipo',
        'sInfoThousands': ',',
        'sLoadingRecords': 'Buscando resultados…',
        'oPaginate': {
          'sFirst': 'Primero',
          'sLast': 'Último',
          'sNext': 'Siguiente',
          'sPrevious': 'Anterior'
        },
        'oAria': {
          'sSortAscending': ': Activar para ordenar la columna de manera ascendente',
          'sSortDescending': ': Activar para ordenar la columna de manera descendente'
        }
      },
      processing: true,
      serverSide: true,
      search: {
        delay: 5000
      },
      searchDelay: 800,
      order: [[0, 'desc']],
      columns: [
        { data: 'publicationSort', orderable: true },
        { data: 'color.name', orderable: false },
        { data: 'fullText', orderable: false },
        { data: 'plate', orderable: false },
        { data: 'dealer.email', orderable: false, visible: this.$store.getters['app/hasRole']('ROLE_ADMIN') },
        { data: 'price', orderable: true },
        { data: 'kilometers', orderable: false },
        // { data: 'plate', orderable: false },
        // { data: 'color.name', orderable: false },
        { data: 'thumbnail', orderable: false },
        { data: 'status', orderable: false, visible: this.$store.getters['app/hasRole']('ROLE_CMS_VIEW_CTC_COL') },
        { data: 'status', orderable: false }
      ],
      ajax: {
        url: `${process.env.API_ENDPOINT}/v1/car/search/datatable`,
        beforeSend: (request, response) => {
          request.setRequestHeader('Authorization', `Bearer ${self.$store.state.app.session.token}`)
          if (window.searchParams !== null) {
            response.url += window.searchParams.replace('?', '&')
          }
          console.log('query', {request, response})
        },
        complete: response => {
          if (response.status === 200) {
          } else {
            this.error = response.responseText
          }
        }
      },
      rowCallback: (row, data) => {
        let cellOffset = 0
        let cellPublicationSort = row.cells[cellOffset++]
        let cellEdit = row.cells[cellOffset++]
        // eslint-disable-next-line
        let fulltext = row.cells[cellOffset++]
        let cellPlate = row.cells[cellOffset++]
        let cellLocation = null
        if (this.$store.getters['app/hasRole']('ROLE_CMS_VIEW_CTC_COL')) {
          cellLocation = row.cells[cellOffset++]
        }
        let cellPrice = row.cells[cellOffset++]

        // eslint-disable-next-line
        let kilometers = row.cells[cellOffset++]
        let cellThumbnail = row.cells[cellOffset++]
        let cellStatus = null
        if (this.$store.getters['app/hasRole']('ROLE_CMS_VIEW_CTC_COL')) {
          cellStatus = row.cells[cellOffset]; cellOffset++
        }

        let cellCochesNet = row.cells[cellOffset++]

        kilometers.innerHTML = `${data.type.name}`

        let cellPublicationSortHtml = moment(data.createdAt).format('YYYY-MM-DD HH:mm:ss')
        // if (data.hasOwnProperty('publicationSort')) {
        //   cellPublicationSortHtml += `<br /><small><b>Última publicación:</b><br />${moment(data.publicationSort * 1000).format('YYYY-MM-DD HH:mm:ss')}</small>`
        // }

        cellPlate.width = '80px'

        cellPublicationSort.innerHTML = cellPublicationSortHtml

        cellPrice.innerHTML = `${data.price} €`
        cellThumbnail.width = '80px'
        cellThumbnail.style.textAlign = 'center'
        cellThumbnail.style.padding = 0
        cellThumbnail.innerHTML = `<img src="${process.env.PICTURE_ENDPOINT}/${data.thumbnail}" alt="thumbnail" style="max-width: 80px; max-height: 64px; margin: 0 auto;" />`

        if (cellLocation !== null) {
          cellLocation.style.textAlign = 'center'
          cellLocation.innerHTML = `<a href="mailto:${data.dealer.email}">${data.dealer.email}</a>`
          if (data.hasOwnProperty('isDealershipReallocated') && !data.isDealershipReallocated) {
            cellLocation.innerHTML += `<hr/><i class="fas fa-exclamation-triangle" style="color: orange"  data-toggle="tooltip" title="La ubicación de este vehículo es incorrecta."></i>`
            cellLocation.innerHTML += `&nbsp;&nbsp;${data.dealership.name}`
          } else {
            cellLocation.innerHTML += `<hr />${data.dealership.name}`
          }
          cellLocation.innerHTML += `<hr />${data.dealership.society.name}`

          cellLocation.style.paddingTop = '0px'
          cellLocation.style.paddingBottom = '0px'
        }

        cellEdit.style.textAlign = 'center'
        cellEdit.classList.add('cellEdit')
        cellEdit.style.verticalAlign = 'center'
        cellEdit.innerHTML = `<a href="/#/cars/${data.code}/edit" target="_blank"><i class="fa fa-edit"></i></a>`

        // cellStatus.style.width = '100px'

        if (cellStatus !== null) {
          let statusLabel = 'DISPONIBLE'
          let statusLabelColor = 'success'
          let statusOptions = `<li><a href="#" onclick="window.tableInstance.methods.setCarReserved('${data.code}')">Marcar como reservado</a></li>`
          statusOptions += `<li><a href="#" onclick="window.tableInstance.methods.setCarSelled('${data.code}')">Marcar como vendido</a></li>`
          statusOptions += `<li><a href="#" onclick="window.tableInstance.methods.setCarUnpublished('${data.code}')">Despublicar</a></li>`
          //
          switch (data.status) {
            case 'RESERVED':
              statusLabel = 'RESERVADO'
              statusLabelColor = 'warning'
              statusOptions = `<li><a href="#" onclick="window.tableInstance.methods.setCarAvailable('${data.code}')">Marcar como disponible</a></li>`
              statusOptions += `<li><a href="#" onclick="window.tableInstance.methods.setCarSelled('${data.code}')">Marcar como vendido</a></li>`
              statusOptions += `<li><a href="#" onclick="window.tableInstance.methods.setCarUnpublished('${data.code}')">Despublicar</a></li>`
              break
            case 'SOLD':
              statusLabel = 'VENDIDO'
              statusLabelColor = 'info'
              statusOptions = `<li><a href="#" onclick="window.tableInstance.methods.setCarAvailable('${data.code}')">Marcar como disponible</a></li>`
              statusOptions += `<li><a href="#" onclick="window.tableInstance.methods.setCarReserved('${data.code}')">Marcar como reservado</a></li>`
              statusOptions += `<li><a href="#" onclick="window.tableInstance.methods.setCarUnpublished('${data.code}')">Despublicar</a></li>`
              break
            case 'UNPUBLISHED':
              statusLabel = 'NO PUBLICADO'
              statusLabelColor = 'default'
              statusOptions = `<li><a href="#" onclick="window.tableInstance.methods.setCarAvailable('${data.code}')">Marcar como disponible</a></li>`
              statusOptions += `<li><a href="#" onclick="window.tableInstance.methods.setCarReserved('${data.code}')">Marcar como reservado</a></li>`
              statusOptions += `<li><a href="#" onclick="window.tableInstance.methods.setCarSelled('${data.code}')">Marcar como vendido</a></li>`
              break
          }

          cellStatus.innerHTML = `<div class="btn-group-vertical" style="margin: 0 auto">
                                  <div class="label label-${statusLabelColor}" style="display:block;">${statusLabel}</div>
                                  <div class="btn-group btn-group-xs">
                                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      Modificar estado <span class="caret"></span>
                                    </button>
                                    <ul class="dropdown-menu">
                                     ${statusOptions}
                                    </ul>
                                  </div>
                                </div>`
        }

        let innerHTML = `<div class="btn-group-vertical">
           <div class="label label-default" style="display: block;">DESPUBLICADO</div>
            <div class="btn btn-xs btn-default publish_cnet" data-code="${data.code}">PUBLICAR</div>
           </div>`

        if (data.hasOwnProperty('publications')) {
          data.publications.forEach((publication) => {
            if (publication.hasOwnProperty('advertiser')) {
              if (publication.advertiser === 4 && data.status !== 'UNPUBLISHED') {
                let cnetPublishStatus = 'PUBLICADO'
                let cnetLabelColor = 'success'

                let cnetPublishOption = `<li><a href="#" class="sell_cnet" data-code="${data.code}">Lo he vendido</a></li>`
                cnetPublishOption += `<li><a href="#" class="reserve_cnet" data-code="${data.code}">Quiero reservarlo</a></li>`
                cnetPublishOption += `<li><a href="#" class="unpublish_cnet" data-code="${data.code}">Solo despublicar</a></li>`
                //
                let extraVisibility = ''
                switch (data.status) {
                  case 'RESERVED':
                    cnetPublishStatus = 'RESERVADO'
                    cnetLabelColor = 'warning'
                    cnetPublishOption = `<li><a href="#" class="sell_cnet" data-code="${data.code}">Lo he vendido</a></li>`
                    cnetPublishOption += `<li><a href="#" class="remove_reserve_cnet" data-code="${data.code}">Quitar reserva</a></li>`
                    break
                  case 'SOLD':
                    cnetPublishStatus = 'VENDIDO'
                    cnetLabelColor = 'info'
                    extraVisibility = ' hide'
                    break
                }

                innerHTML = `<div class="btn-group-vertical" style="margin: 0 auto">
                                  <div class="label label-${cnetLabelColor}" style="display:block;">${cnetPublishStatus}</div>
                                  <div class="btn-group btn-group-xs">
                                    <button type="button" class="btn btn-default dropdown-toggle${extraVisibility}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      Modificar estado <span class="caret"></span>
                                    </button>
                                    <ul class="dropdown-menu">
                                     ${cnetPublishOption}
                                    </ul>
                                  </div>
                                </div>`
              }
            }
          })
        }
        // cellCochesNet.innerHTML = `<div class="btn-group-vertical">
        //   <div class="label label-${cnetLabelColor}" style="display: block;">${cnetPublishStatus}</div>${cnetPublishOption}</div>`
        cellCochesNet.innerHTML = innerHTML
      }
    })

    window.$('.datatable').on('draw.dt', function () {
      window.$('.sell_cnet').unbind('click')
      window.$('.reserve_cnet').unbind('click')
      window.$('.unpublish_cnet').unbind('click')
      window.$('.publish_cnet').unbind('click')
      window.$('.remove_reserve_cnet').unbind('click')

      window.$('.sell_cnet').on('click', function (event) {
        event.preventDefault()
        EventBus.$emit('sellCarCnetEvent', { code: window.$(this).attr('data-code') })
      })

      window.$('.reserve_cnet').on('click', function (event) {
        event.preventDefault()
        EventBus.$emit('reserveCnetEvent', { code: window.$(this).attr('data-code') })
      })

      window.$('.unpublish_cnet').on('click', function (event) {
        event.preventDefault()
        EventBus.$emit('unpublishCnetEvent', { code: window.$(this).attr('data-code') })
      })

      window.$('.publish_cnet').on('click', function (event) {
        event.preventDefault()
        EventBus.$emit('publishCnetEvent', { code: window.$(this).attr('data-code') })
      })

      window.$('.remove_reserve_cnet').on('click', function (event) {
        event.preventDefault()
        EventBus.$emit('unReserveCnetEvent', { code: window.$(this).attr('data-code') })
      })
    })
  }
}

export default window.tableInstance
</script>

<style lang="scss">
    @import 'datatables.net-bs/css/dataTables.bootstrap.min.css';

    #datatable_wrapper {
        img {
            max-width: 150px;
            @media(max-width: 768px) {
                max-width: 50px !important;
            }
        }
        .row:nth-child(1) .col-sm-6:nth-child(1) {
            display:none !important;
        }
        .dataTables_filter {
            text-align: left;
        }

        hr {
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    .cellEdit {
        a {
            text-decoration: none;
            /*color: #358be2;*/
          font-size: 1.4em;
        }
    }

    .form-group {
      .help-block {
        display: none;
      }
    }

    .form-group.has-error {
      .help-block {
        display: block !important;
      }
    }

    .overlay {
        z-index:9999;
    }

   #textMotive {
     display: none;
     margin-top: 10px;
   }
</style>



// WEBPACK FOOTER //
// src/components/pages/CarsSearch/SearchCarsDatatable.vue